import { tryOnUnmounted, useElementSize } from '@vueuse/core';
import { nextTick, type Ref, ref, watch } from 'vue';

interface UseBodyReturn {
  isBodyMounted: Ref<boolean>;
  bodySize: {
    width: Ref<number>;
    height: Ref<number>;
  };
}

export const useBody = (): UseBodyReturn => {
  const isBodyMounted = ref<boolean>(false);
  const bodyEl = document.body;
  const bodySize = useElementSize(bodyEl, {
    width: bodyEl.offsetWidth,
    height: bodyEl.offsetHeight,
  });

  const watchStop = watch(
    () => bodySize,
    () => nextTick(() => {
      if (bodySize.height.value) {
        isBodyMounted.value = true;
        watchStop();
      }
    }),
    { immediate: true, deep: true },
  );

  tryOnUnmounted(() => watchStop());

  return {
    isBodyMounted,
    bodySize,
  };
};
